import './js/jquery-global';
import 'bootstrap';

// keep these scss files as separate modules for faster builds (import here instead of in the global scss)
import './styles/bootstrap.scss';
import './styles/app.scss';

import './js/form';
import './js/components/teleport'; // must run before other components so teleported nodes exist when they mount
import './js/components';